import { useContext, useEffect, useState } from 'react';
import useSmartState from '../../../common/hooks/useSmartState';
import FormBuilder from '../../../library/Builders/FormBuilder';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import { FormSection } from '../../../library/Core/SmartTypes';
import FiltersApplied from '../../../library/SimpleControls/FiltersApplied';
import AiSuggestedService from './AiSuggestedService';

export const AiSuggestedSearchCriteria = () => {
    const { state } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const searchFormConfig = state.formConfig?.sectionRepository[0] as FormSection;
    const [isExpanded, setIsExpanded] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const searchCriteria = state.data?.searchCriteria || {};
    const fuzzySearchPlaceholder = searchFormConfig?.fuzzySearchPlaceholder || 'Search by Name, Service, or Location...';

    const filterSignature = JSON.stringify({
        fuzzySearchText: searchCriteria.fuzzySearchText,
        institutes: searchCriteria.institutes,
        countryCode: searchCriteria.countryCode,
        cityCode: searchCriteria.cityCode,
        confidenceRange: searchCriteria.confidenceRange,
    });

    useEffect(() => {
        if (isInitialLoad) {
            setIsInitialLoad(false);
            return;
        }

        const criteriaForSearch = { ...searchCriteria, page: 1 };
        if ((searchCriteria.page || 1) !== 1) {
            setStateValue('searchCriteria.page', 1 as any);
        }

        AiSuggestedService.search(criteriaForSearch)
            .then((response: any) => {
                const payload = response?.data ?? {};
                setStateValue('providerList', payload?.data ?? []);
                setStateValue('pagination', {
                    total: payload?.total ?? 0,
                    page: payload?.page ?? 1,
                    limit: payload?.limit ?? state.data.searchCriteria?.limit ?? 20,
                } as any);
            })
            .catch((error) => {
                console.error('Error searching AI suggestions:', error);
            });
    }, [filterSignature]);

    const handleClearAll = () => {
        const defaultCriteria = AiSuggestedService.getDefaultSearchCriteria();
        setFuzzySearchText('');
        setStateValue('searchCriteria', defaultCriteria);
    };

    const handleFuzzySearch = (event: any) => {
        event.preventDefault();
        const mergedCriteria = {
            ...searchCriteria,
            fuzzySearchText: fuzzySearchText?.trim(),
            page: 1,
        };
        setStateValue('searchCriteria', mergedCriteria as any);
    };

    return (
        <div className="search_criteria">
            <div className="filter_section">
                <div className="row justify-content-between align-items-end flex-column-reverse flex-sm-row">
                    <div className="col">
                        <div className="d-flex flex-wrap justify-content-end filterSearch">
                            <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                                <div
                                    className="filter_header cursor-pointer d-flex me-2"
                                    onClick={() => setIsExpanded(!isExpanded)}>
                                    <h5
                                        className={`font-16 font-600 mb-0 ${
                                            isExpanded ? 'rounded-4 rounded-bottom-0' : 'rounded-pill'
                                        } bg-gray-F2F4F7 px-4 py-2`}>
                                        <span className="py-1 d-block">
                                            <i className="bi bi-funnel-fill"></i> Filters
                                        </span>
                                    </h5>
                                </div>
                                <div className="search alumniSearch m-0 open position-static flex-1">
                                    <form
                                        className="form-inline d-flex flex-wrap justify-content-between d-block"
                                        onSubmit={handleFuzzySearch}>
                                        <input
                                            value={fuzzySearchText}
                                            placeholder={fuzzySearchPlaceholder}
                                            aria-label="Search"
                                            className="form-control flex-1 font-13 font-500 text-truncate"
                                            onChange={(event) => setFuzzySearchText(event?.target.value)}
                                        />
                                        <button className="btn btn-search icon icon-search" type="submit"></button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Export button removed for AI Suggested per ticket — these are pending suggestions, not exportable */}
                </div>

                {isExpanded && (
                    <>
                        <div className="filter_body p-4 bg-gray-F2F4F7 rounded">
                            <FormBuilder key="searchCriteria" section={searchFormConfig} dataKey="searchCriteria" />
                        </div>

                        <div className="filter_actions p-3 d-flex gap-2">
                            <button className="btn btn-green btn-sm" onClick={handleClearAll}>
                                Clear All
                            </button>
                        </div>
                    </>
                )}
            </div>

            {!isEmpty(state.data.searchCriteria) && (
                <FiltersApplied filters={state.data.searchCriteria} onClear={handleClearAll} />
            )}
        </div>
    );
};
